import { axios } from "../lib/axios";

/**
 * Fetch all filter presets for the current user
 * @return {Promise} Array of filter presets
 */
const getFilterPresets = () => {
  return axios.get("filter-presets/");
};

/**
 * Create a new filter preset
 * @param {Object} data - The preset data
 * @param {string} data.name - Name of the preset
 * @param {Array} data.filters - Filter configuration
 * @return {Promise} Created preset object
 */
const postFilterPreset = (data) => {
  return axios.post("filter-presets/", data);
};

/**
 * Delete a filter preset
 * @param {number} presetId - ID of the preset to delete
 * @return {Promise} Deletion confirmation
 */
const deleteFilterPreset = (presetId) => {
  return axios.delete(`filter-presets/${presetId}/`);
};

/**
 * Update an existing filter preset
 * @param {number} presetId - ID of the preset to update
 * @param {Object} data - Updated preset data
 * @return {Promise} Updated preset object
 */
const updateFilterPreset = (presetId, data) => {
  return axios.put(`filter-presets/${presetId}/`, data);
};

/**
 * Get a specific filter preset by ID
 * @param {number} presetId - ID of the preset
 * @return {Promise} Preset object
 */
const getFilterPreset = (presetId) => {
  return axios.get(`filter-presets/${presetId}/`);
};

export default getFilterPresets;
export {
  postFilterPreset,
  deleteFilterPreset,
  updateFilterPreset,
  getFilterPreset,
};
